import toolsClient from "@/api/toolsClient"
import { MULTIPART_HEADERS } from "@/api/apiUtils"

const buildFormData = ({ formData, file }) => {
  const body = new FormData()

  body.append("post", JSON.stringify(formData))

  if (file) {
    body.append("file", file)
  }

  return body
}

export const getAll = async () => {
  const response = await toolsClient.get("/tools/posts")

  return response.data
}

export const create = async (data) => {
  const response = await toolsClient.post("/tools/posts", buildFormData(data), MULTIPART_HEADERS)

  return response.data
}

export const update = async (postKey, data) => {
  const response = await toolsClient.put(
    `/tools/posts/${encodeURIComponent(postKey)}`,
    buildFormData(data),
    MULTIPART_HEADERS
  )

  return response.data
}

export const get = async (postKey) => {
  const response = await toolsClient.get(`/tools/posts/${encodeURIComponent(postKey)}`)

  return response.data
}

export const remove = async (postKey) => {
  const response = await toolsClient.delete(`/tools/posts/${encodeURIComponent(postKey)}`)

  return response.data
}
